export default __webpack_public_path__ + "static/media/activity.177d7b2e.png";